import { useEffect } from 'react';

import { GlobalScrollLock } from 'components/GlobalScrollLock';

import * as styled from '../styles';
import { downloadFilename } from '../helpers';

type Props = {
  url: string | null;
  onClose: () => void;
};

export const Lightbox = ({ url, onClose }: Props) => {
  useEffect(() => {
    if (!url) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [url, onClose]);

  if (!url) return null;
  return (
    <styled.LightboxOverlay onClick={onClose}>
      <GlobalScrollLock />
      <styled.LightboxContent onClick={(e) => e.stopPropagation()}>
        <styled.LightboxImage src={url} alt="" />
        <styled.LightboxActions>
          <styled.LightboxAction
            href={url}
            download={downloadFilename(url)}
            target="_blank"
            rel="noreferrer noopener"
          >
            ↓ Download
          </styled.LightboxAction>
          <styled.LightboxAction as="button" type="button" onClick={onClose}>
            Close
          </styled.LightboxAction>
        </styled.LightboxActions>
      </styled.LightboxContent>
    </styled.LightboxOverlay>
  );
};
